import { useMemo } from 'react'
import { isEmpty } from 'lodash'

import { getPrintableGender } from 'util/member'
import { getPrintableLanguages } from 'util/languages'
import Provider from 'types/provider/provider'
import ProviderInfoDetailSection from '../ProviderInfoDetailSection'
import { getPrintableShortProviderName } from 'util/provider'

type ProviderInfoOldProps = {
  provider: Provider
}

const ProviderInfoOld = ({ provider }: ProviderInfoOldProps) => {
  const { specialtyFocus, bio } = provider || {}

  const { gender, languages } = useMemo(() => {
    const languageArray = (provider && provider.languages) || []
    return {
      gender: getPrintableGender(provider) || 'N/A',
      languages: getPrintableLanguages(languageArray),
    }
  }, [provider])

  if (!provider) {
    return null
  }

  return (
    <>
      <ProviderInfoDetailSection title={'Sex'} subtitle={gender} />
      {!!languages && <ProviderInfoDetailSection title={'Languages'} subtitle={languages} />}
      {!isEmpty(bio) && <ProviderInfoDetailSection title={'Bio'} value={bio} />}
      {!isEmpty(specialtyFocus) && (
        <ProviderInfoDetailSection title={'Areas of focus'} value={specialtyFocus.join(', ')} />
      )}
    </>
  )
}

export default ProviderInfoOld
